import { jsx as _jsx } from "react/jsx-runtime";
export const useHighlightableText = props => {
  if (props.ranges) {
    const result = [];
    let lastIndex = 0;
    const ranges = [...props.ranges].sort(([startA], [startB]) => startA - startB);
    ranges.forEach(([start, end], index) => {
      if (Number.isInteger(start) && Number.isInteger(end) && start >= 0 && end >= start && start >= lastIndex) {
        if (start > lastIndex) {
          result.push(props.text.slice(lastIndex, start));
        }
        result.push( /*#__PURE__*/_jsx("mark", {
          className: props.className,
          style: props.style,
          children: props.text.slice(start, end + 1)
        }, index));
        lastIndex = end + 1;
      }
    });
    if (lastIndex < props.text.length) {
      result.push(props.text.slice(lastIndex));
    }
    return result;
  }
  if (props.highlight) {
    const highlights = typeof props.highlight === 'string' ? [props.highlight] : props.highlight;

    // do not care for any special character
    const regex = new RegExp(`(${highlights.map(escape).join('|')})`, !props.caseSensitive ? 'gi' : 'g');
    return !regex.test(props.text) ? props.text : props.text.split(regex).map((part, index) => regex.test(part) ? /*#__PURE__*/_jsx("mark", {
      className: props.className,
      style: props.style,
      children: part
    }, index) : part);
  }
  return props.text;
};
const escape = text => text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
//# sourceMappingURL=useHighlightableText.js.map